export default {
  scoreRecord: '/clientEcosys/courierLevel/scoreRecord'
}
